import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/South';
import KeyboardArrowUpIcon from '@mui/icons-material/North';

import { SortOptions, SortType } from '../../../enums/SORT';
import styles from './SharedVideosListHeader.module.scss';
import DateSortHeader from '../../modules/DateSortHeader';

type TSharedWithMeFoldersHeader = {
  onNameClick?: () => void;
  onSizeClick?: () => void;
  onDateSort?: (_: SortOptions, option: { label: string; value: SortOptions; order: SortType }) => void;
  onOwnerClick?: () => void;
  sort: SortType;
  sortOption: SortOptions;
};

export const SharedVideosListHeader: React.FC<TSharedWithMeFoldersHeader> = ({
  onNameClick,
  sort,
  sortOption,
  onSizeClick,
  onDateSort,
  onOwnerClick,
}) => {
  return (
    <div className={styles.videosListHeader} style={{ cursor: 'default' }}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.name} onClick={onNameClick} style={{ cursor: 'pointer' }}>
            Name
            {sortOption === SortOptions.NAME && sort === SortType.ASC && (
              <>
                <KeyboardArrowDownIcon className={styles.arrow} />
              </>
            )}
            {sortOption === SortOptions.NAME && sort === SortType.DESC && (
              <>
                <KeyboardArrowUpIcon className={styles.arrow} />
              </>
            )}
          </div>
          <div className={styles.owner} onClick={onOwnerClick}>
            Owner
            {sortOption === SortOptions.OWNER && sort === SortType.DESC && (
              <>
                <KeyboardArrowDownIcon className={styles.arrow} />
              </>
            )}
            {sortOption === SortOptions.OWNER && sort === SortType.ASC && (
              <>
                <KeyboardArrowUpIcon className={styles.arrow} />
              </>
            )}
          </div>
          <div className={styles.access}>Access</div>
          <div className={styles.uploadedAt}>
            <DateSortHeader
              sortOption={sortOption}
              sort={sort}
              onSelect={(value, option) => onDateSort?.(value, option)}
              arrowClassName={styles.arrow}
            />
          </div>
          <div className={styles.fileSize} onClick={onSizeClick} style={{ cursor: 'pointer' }}>
            Size
            {sortOption === SortOptions.SIZE && sort === SortType.DESC && (
              <>
                <KeyboardArrowDownIcon className={styles.arrow} />
              </>
            )}
            {sortOption === SortOptions.SIZE && sort === SortType.ASC && (
              <>
                <KeyboardArrowUpIcon className={styles.arrow} />
              </>
            )}
          </div>
          <div className={styles.action}>Actions</div>
        </div>
      </div>
    </div>
  );
};
